import type { Phrase } from '../types';
import type { exploreEn } from './explore.en';

export const exploreMl: Partial<Record<keyof typeof exploreEn, Phrase>> = {
  // header + top search bar
  exEyebrow: 'വേദികൾ കണ്ടെത്തുക',
  exLead: 'സ്ഥലം, തീയതി, പരിപാടി, അതിഥികളുടെ എണ്ണം എന്നിവ നൽകി പരിശോധിച്ചുറപ്പിച്ച വേദികൾ തിരയൂ; രണ്ടെണ്ണം ഒരുമിച്ച് താരതമ്യം ചെയ്ത് അഭ്യർത്ഥന അയയ്ക്കൂ.',
  exSearchLabel: 'വേദി, പ്രദേശം അല്ലെങ്കിൽ നഗരം',
  exLocation: 'സ്ഥലം',
  exAnyLocation: 'ഏത് സ്ഥലവും',
  exDate: 'തീയതി',
  exEventType: 'പരിപാടിയുടെ തരം',
  exAnyEvent: 'ഏത് പരിപാടിയും',
  exOccasionAll: '{name} (എല്ലാ തരവും)',
  exGuestsPlaceholder: 'എത്ര പേർ?',
  exGuestCount: 'അതിഥികളുടെ എണ്ണം',
  exGuestCountHint: 'ഇത്രയും അതിഥികളെ (ഇരിക്കുന്നവരും നിൽക്കുന്നവരും) ഉൾക്കൊള്ളാനാകുന്ന വേദികൾ കാണിക്കുന്നു.',
  exGuestsRule: 'അതിഥികളുടെ എണ്ണം 1-ഓ അതിൽ കൂടുതലോ ഉള്ള പൂർണ്ണസംഖ്യ ആയിരിക്കണം',
  exClearDate: 'തീയതി മായ്ക്കുക',

  // filters
  exFilters: 'ഫിൽട്ടറുകൾ',
  exFiltersTitle: 'വേദികൾ ഫിൽട്ടർ ചെയ്യുക',
  exVenueType: 'വേദിയുടെ തരം',
  exMaxPrice: 'മണിക്കൂറിന് പരമാവധി നിരക്ക് (₹)',
  exFacilities: 'സൗകര്യങ്ങൾ',
  exAc: 'എയർ കണ്ടീഷൻ ചെയ്തത്',
  exNonAc: 'നോൺ-എസി മാത്രം',
  exMinRating: 'അതിഥി റേറ്റിംഗ്',
  exRatingAny: 'ഏതും',
  exRatingN: '{n}+',
  exRatingHint: 'റിവ്യൂ ഉള്ള വേദികൾ മാത്രമേ കണക്കാക്കൂ.',
  exSaved: 'സേവ് ചെയ്ത വേദികൾ മാത്രം',
  exSavedHint: { one: 'ഈ ബ്രൗസറിൽ {count} വേദി സേവ് ചെയ്തിട്ടുണ്ട്', other: 'ഈ ബ്രൗസറിൽ {count} വേദികൾ സേവ് ചെയ്തിട്ടുണ്ട്' },
  exClose: 'ഫിൽട്ടറുകൾ അടയ്ക്കുക',
  exClearAll: 'എല്ലാം മായ്ക്കുക',
  exShowResults: 'വേദികൾ കാണിക്കുക',

  // active filter chips
  exActiveFilters: 'സജീവ ഫിൽട്ടറുകൾ',
  exRemoveChip: 'ഫിൽട്ടർ നീക്കുക: {label}',
  exChipSearch: '“{text}”',
  exChipGuests: '{count} അതിഥികൾക്ക് ഇടമുണ്ട്',
  exChipMaxPrice: 'മണിക്കൂറിന് {price} വരെ',
  exChipRating: '{n}★ മുതൽ',
  exChipDate: '{date}-ന് ഒഴിവ്',
  exChipSaved: 'സേവ് ചെയ്തവ മാത്രം',

  // results
  exSortLabel: 'ക്രമീകരിക്കുക',
  exSortRecommended: 'ശുപാർശ ചെയ്തവ',
  exSortRating: 'ഉയർന്ന റേറ്റിംഗ്',
  exSortReviews: 'കൂടുതൽ റിവ്യൂകൾ',
  exSortCapacity: 'കൂടുതൽ ശേഷി',
  exView: 'കാഴ്ച',
  exViewGrid: 'ഗ്രിഡ് കാഴ്ച',
  exViewList: 'ലിസ്റ്റ് കാഴ്ച',
  exUpdating: 'ഫലങ്ങൾ പുതുക്കുന്നു…',
  exErrorBody: 'ഇന്റർനെറ്റ് കണക്ഷൻ പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക.',
  exRetry: 'വീണ്ടും ശ്രമിക്കുക',
  exEmptyTitle: 'വേദികളൊന്നും കണ്ടെത്തിയില്ല',
  exEmptyBody: 'നിങ്ങളുടെ തിരയലിന് യോജിച്ച വേദിയില്ല. മറ്റൊരു സ്ഥലമോ തീയതിയോ നോക്കൂ, അല്ലെങ്കിൽ ഒരു ഫിൽട്ടർ മാറ്റൂ.',
  exEmptySavedBody: 'നിങ്ങൾ ഇതുവരെ വേദികളൊന്നും സേവ് ചെയ്തിട്ടില്ല. ഒരു വേദിയിലെ ഹൃദയ ചിഹ്നം തൊട്ടാൽ അത് ഇവിടെ സൂക്ഷിക്കാം.',
  exNoVenuesTitle: 'ഇതുവരെ വേദികളൊന്നും ലിസ്റ്റ് ചെയ്തിട്ടില്ല',
  exNoVenuesBody: 'പരിശോധന കഴിഞ്ഞാൽ വേദികൾ ഇവിടെ കാണാം. ദയവായി പിന്നീട് നോക്കൂ.',

  // helper strip
  exHelpTitle: 'തീരുമാനിക്കാൻ പ്രയാസമുണ്ടോ?',
  exHelpBody: 'പരിപാടി അനുസരിച്ച് വേദികൾ കാണൂ, ആസൂത്രണ ആശയങ്ങൾ നേടൂ, അല്ലെങ്കിൽ ആവശ്യം ഞങ്ങളോട് പറയൂ — തിരഞ്ഞെടുക്കാൻ ഞങ്ങൾ സഹായിക്കാം.',
  exHelpOccasions: 'പരിപാടി അനുസരിച്ച് കാണുക',
  exHelpInspiration: 'ആശയങ്ങൾ നേടുക',
  exHelpContact: 'ഞങ്ങളോട് സംസാരിക്കൂ',

  // night edition
  exCrumbs: 'ബ്രെഡ്ക്രംബ്',
  exCrumbHome: 'ഹോം',
  exTitleLead: 'നിങ്ങളുടെ',
  exTitleAccent: 'വേദി കണ്ടെത്തൂ',
  exResultsWord: { one: 'വേദി ലഭ്യമാണ്', other: 'വേദികൾ ലഭ്യമാണ്' },
  exNoMatch: 'ഈ ഫിൽട്ടറുകൾക്ക് യോജിച്ച വേദികൾ ഇതുവരെ ഇല്ല.',
  exFavSaved: '{name} സേവ് ചെയ്തു',
  exFavRemoved: 'സേവ് ചെയ്തവയിൽ നിന്ന് നീക്കി',
  exCompareTray: 'വേദികൾ താരതമ്യം ചെയ്യുക',
  exCompareReady: '2 വേദികൾ തിരഞ്ഞെടുത്തു',
  exCompareClear: 'താരതമ്യം മായ്ക്കുക',
  exCmpTitle: 'അടുത്തടുത്ത്',
  exCmpBetter: 'ഇതിൽ മികച്ചത്',
};
